import React, { useState, useEffect } from 'react';
import { Container } from '@material-ui/core';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { AppBar, Button, Typography, Avatar, Toolbar, Grid } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import decode from 'jwt-decode';
import { AUTH_ACTION } from '../../interface';
import useStyles from './styles';
import appBarLogo from '../../assets/logo/logo.png';
import instagramIcon from '../../assets/icons/social media/instagram_icon.svg';
import fbIcon from '../../assets/icons/social media/facebook_icon.svg';
import twitterIcon from '../../assets/icons/social media/twitter_icon.svg';
import flare_logo from '../../assets/logo/logo.png';
import useCommonStyles from '../CommonStyle/commonStyle';
import PopModal from '../PopModal/PopModal';



// function useQuery() {
//     return new URLSearchParams(useLocation().search);
// }

const Footer = () => {

    const classes = useStyles();
    const commonClasses = useCommonStyles();
    const path = useLocation().pathname;
    const released = true;

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const onClick = () => {
        var link = "https://forms.gle/a6AF2QLrMYXnVBPA8"
        window.open(link, "_blank");
    };

    // console.log(location);


    return (

        <div className={classes.footerContainer}>
            <Container maxWidth="lg" className={classes.boxContainer}>

                {path === "/startup" && (
                    <>
                        <div className={classes.footerBox}>
                            <Typography component={'span'} variant="h3" >
                                さぁ、さっそく登録してみよう<br />
                            </Typography>
                            <Typography component={'span'} variant="h6" >
                                <br /> あなたのプロジェクトをより大きなものへ。
                            </Typography >
                            <br />
                            {
                            process.env.REACT_APP_STAGE !== 'prod'? (
                                <>
                                    <Button component={Link} to="/startup/signup" className={classes.signupButton}>新規登録</Button>
                                    <Button component={Link} to="/startup/login" className={classes.loginButton}>ログイン</Button>
                                </>
                            ) : (
                                <>
                                    <Button component={Link} to="#" className={classes.signupButton} onClick={handleOpen}>新規登録</Button>
                                    <Button component={Link} to="#" className={classes.loginButton} onClick={handleOpen}>ログイン</Button>
                                    <PopModal setOpen={setOpen} open={open} />
                                </>)
                        }
                            {/* <Button component={Link} to="/signup" className={classes.signupButton}>新規登録</Button>
                            <Button component={Link} to="/login" className={classes.loginButton}>ログイン</Button> */}
                            <br />
                            <br />
                            {/* <Typography component={'span'} variant="subtitle2" >
                        <br />　<br /> 企業担当の方はこちら
                    </Typography > */}
                            <Button  component={Link} to="/enterprise">
                                企業担当の方はこちら
                            </Button >
                        </div>
                        <div className={classes.snsBox}>
                            <img src={instagramIcon} alt="instagram" className={classes.snsLogo} />
                            <img src={fbIcon} alt="fb" className={classes.snsLogo} />
                            <img src={twitterIcon} alt="twitter" className={classes.snsLogo} />
                        </div>
                    </>)}


                <div className={classes.bottomFooter}>
                    <img src={flare_logo} alt="flare" height={24}/> <br /><br />
                    <Grid container justifyContent="space-between">
                        <Typography display='inline' component={'span'} variant="subtitle1"　>
                            <a href='https://www.sustainablegame.com' className={classes.link}>運営会社</a>　/　<a href='https://www.sustainablegame.com/?page_id=897' className={classes.link}>プライバシーポリシー</a>　/　<a href='' className={classes.link}>企業担当の方はこちら</a>　/　<a href='https://www.sustainablegame.com/?page_id=210' className={classes.link} >お問い合わせ</a>
                        </Typography>
                        <Typography display='inline' variant="subtitle1" >©︎Flare 2021.</Typography>
                    </Grid>
                </div>

            </Container>
        </div >


    )
}

export default Footer;